import { HelperService } from '../helper.service';

export class WebSupplierMetrics {
	public name: string;
	public logo: string;

	constructor(webSupplierMetrics: WebSupplierMetrics) {
		Object.assign(this, webSupplierMetrics);

		this.logo = this.logo ? HelperService.getPath(this.logo, true) : this.logo;
	}
}
